import { render, staticRenderFns } from "./WapWDD001Operate.vue?vue&type=template&id=4c71945d&scoped=true&"
import script from "./WapWDD001Operate.vue?vue&type=script&lang=js&"
export * from "./WapWDD001Operate.vue?vue&type=script&lang=js&"
import style0 from "./WapWDD001Operate.vue?vue&type=style&index=0&id=4c71945d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71945d",
  null
  
)

export default component.exports